import type { KimPageTypeProps, RatingValue } from './KimRating.types';
import { useIFrameUrl } from './useIFrameUrl';

/**
 * Renders the dialog content for the KimRating component.
 *
 * @param props - The component props.
 * @returns The rendered dialog content.
 */
export const KimRatingDialogContent = ({
  ratingValue,
  pageType,
}: {
  ratingValue: RatingValue;
  pageType: KimPageTypeProps;
}) => (
  <iframe
    title="kim"
    width="100%"
    height="600"
    style={{ border: 0, overflow: 'hidden' }}
    src={useIFrameUrl({
      ratingValue,
      pageType,
    })}
  />
);
